import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, debounceTime, startWith, mergeMap } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error/index';
import * as R from 'ramda';
import { addNotification, replaceNotification } from 'common/mdc/notifications/actions';
import {
  TYPE_SUCCESS, TYPE_ERROR, TYPE_PENDING,
} from 'common/mdc/notifications/notification';
import { Subject, merge, of } from 'rxjs';
import { PublicError } from 'common/service/error';
import {
  LOAD, load, loadSuccess, loadError,
  download,
  downloadSuccess,
  downloadError,
  TOGGLE_SORT, SEARCH, PAGINATION_CHANGE,
  DOWNLOAD,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_ERROR,
} from './actions';

import {
  getStoreParams,
} from './selectors';

const successText = (response) => {
  switch (response.status) {
    case 206:
      return "Meter alarm data partially downloaded";
    default:
      return "Meter alarm data downloaded";
  }
};

const loadEpic = (action, state, { deviceService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => deviceService
    .getAlarms(getStoreParams(state.value))
    .pipe(
      map(loadSuccess),
      catchError(createErrorStream(action$, loadError)),
    )),
);

const downloadEpic = (action, state, { deviceService }) => action.pipe(
  ofType(DOWNLOAD),
  mergeMap((action$) => {

    const pendingNotification = addNotification({
      autoHide: false,
      type: TYPE_PENDING,
      text: "Meter alarm data download in progress"
    });
    const failureMessage = "";

    return deviceService
    .downloadAlarms(getStoreParams(state.value))
      .pipe(
        mergeMap((response) => of(
          replaceNotification(pendingNotification.notification, {
            type: TYPE_SUCCESS,
            autoHide: true,
            text: successText(response),
          }),
        )),
        startWith(pendingNotification),
        catchError(createErrorStream(
          action$,
          err => replaceNotification(pendingNotification.notification, {
            type: TYPE_ERROR,
            autoHide: true,
            text: R.is(PublicError, err) && err.message
                ? err.message
                : err.status === 429 ? "Too many requests. Please try again later." : failureMessage,
          }),
        )),
      );
  }),
);

const updateEpic = action => action.pipe(
  ofType(TOGGLE_SORT, PAGINATION_CHANGE),
  map(load),
);

const searchEpic = action => action.pipe(
  ofType(SEARCH),
  debounceTime(150),
  map(load),
);

export default combineEpics(
  loadEpic,
  downloadEpic,
  updateEpic,
  searchEpic,
);
